export default __webpack_public_path__ + "static/media/linkedin.259a42f9.svg";